/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

export type EnergyUsageFuelType =
  (typeof EnergyUsageFuelType)[keyof typeof EnergyUsageFuelType]

export const EnergyUsageFuelType = {
  GAS: "GAS",
  ELECTRICITY: "ELECTRICITY",
} as const
